import React from 'react';
import { Layers, Hammer, Grid, Truck, ArrowUp } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/Card';
export function SurfaceTypesSection() {
  const surfaces = [{
    icon: Layers,
    title: 'New Concrete Pour',
    description: 'The gold standard. Cables/tubing are embedded directly in fresh concrete. Cleanest install, best thermal contact.',
    labor: 'Standard',
    schedule: '+2-3 days for curing'
  }, {
    icon: Hammer,
    title: 'Tear-Out & Replace',
    description: 'Existing surface is removed, base is prepared, system is installed, new surface is poured/laid. Most common for retrofits.',
    labor: 'Higher (demolition)',
    schedule: '+1-2 days'
  }, {
    icon: Grid,
    title: 'Under Pavers/Interlock',
    description: 'Pavers are lifted, system is installed on prepared base, pavers are reinstalled. Great option if you love your existing pavers.',
    labor: 'Moderate',
    schedule: 'Similar to new pour'
  }, {
    icon: Truck,
    title: 'Asphalt',
    description: 'Electric cables can be installed under asphalt. Requires careful temperature management during paving.',
    labor: 'Standard',
    schedule: 'Weather-dependent'
  }, {
    icon: ArrowUp,
    title: 'Stairs & Landings',
    description: 'Smaller zones with precise cable placement. Critical for safety. Often combined with walkway systems.',
    labor: 'Detailed work',
    schedule: '1 day typically'
  }];
  return <section className="py-16 bg-slate-50 md:py-24" data-id="element-549">
      <div className="container mx-auto px-4 md:px-6" data-id="element-550">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-551">
          <h2 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl" data-id="element-552">
            What Changes by Surface Type?
          </h2>
          <p className="mt-4 text-lg text-slate-600" data-id="element-553">
            Every material requires a slightly different approach. Here's how
            your specific surface impacts the project.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-554">
          {surfaces.map((surface, index) => <Card key={index} className="border-slate-200 hover:border-primary/30 transition-colors duration-300" data-id="element-555">
              <CardHeader className="pb-3" data-id="element-556">
                <div className="w-12 h-12 rounded-lg bg-white border border-slate-200 flex items-center justify-center mb-4 text-primary shadow-sm" data-id="element-557">
                  <surface.icon className="h-6 w-6" data-id="element-558" />
                </div>
                <CardTitle className="text-xl" data-id="element-559">{surface.title}</CardTitle>
              </CardHeader>
              <CardContent data-id="element-560">
                <p className="text-slate-600 mb-6 min-h-[80px]" data-id="element-561">
                  {surface.description}
                </p>
                <div className="flex flex-wrap gap-2" data-id="element-562">
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium bg-slate-100 text-slate-700 border border-slate-200" data-id="element-563">
                    Labor: {surface.labor}
                  </span>
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium bg-slate-100 text-slate-700 border border-slate-200" data-id="element-564">
                    Time: {surface.schedule}
                  </span>
                </div>
              </CardContent>
            </Card>)}
        </div>

        <div className="text-center" data-id="element-565">
          <p className="text-sm text-slate-500 italic bg-white inline-block px-4 py-2 rounded-full border border-slate-200" data-id="element-566">
            Not sure which applies to you? That is exactly what the site
            assessment determines.
          </p>
        </div>
      </div>
    </section>;
}